module.exports = __webpack_public_path__ + "media/images/new-48-e0c203747ab06ca8c87e9e70440bd6c0.png";